import _ from 'lodash';

export const isEmptyAllValue = (obj) => {
  for (let key in obj) {
    if (obj[key] !== null && obj[key] !== '') return false;
  }
  return true;
};

export const arrayValueToString = (array) => {
  let result = '';

  _.forEach(array, (value, index) => {
    if (index + 1 !== array.length) {
      result += `${value},`;
    } else {
      result += value;
    }
  });

  return result;
};

export const openInNewWindow = (url, width = 800, height = 600) => {
  const left = window.screen.width / 2 - width / 2;
  const top = window.screen.height / 2 - height / 2;

  const newWindow = window.open(
    url,
    '_blank',
    `noopener,noreferrer,width=${width},height=${height},top=${top},left=${left}`
  );

  if (newWindow) newWindow.opener = null;
};

export const getMetaMaskProvider = () => {
  if (window.ethereum?.providers) {
    return window.ethereum.providers.find((provider) => provider.isMetaMask);
  } else if (window.ethereum?.isMetaMask) {
    return window.ethereum;
  }
  return null;
};

export function fullPublicUrl(path) {
  if (!path) return path;
  if (path.startsWith('https://') || path.startsWith('http://')) return path;
  const publicUrl = process.env.REACT_APP_PUBLIC_URL || '';
  return `${publicUrl}${path}`;
}

export function getStaticPathWithPublicUrl(path) {
  if (!path) return path;
  const staticIndex = path.indexOf('/static');
  if (staticIndex !== -1) {
    return path.slice(staticIndex);
  }
  return path;
}
